const initPriceCalculations = () => {
    const checkboxOptionalsArray = document.querySelectorAll(".showcase-product.is-visible [data-prices-container] label");
    if (checkboxOptionalsArray) {
        checkboxOptionalsArray.forEach((checkboxOptional) => {
            checkboxOptional.addEventListener("click", () => {
                const input = checkboxOptional.parentElement.querySelector("[data-price-checkbox]");
                const hiddenInput = input.parentElement.querySelector("[data-value-checkbox]");
                setTimeout(() => {
                    if (input.checked == true) {
                        hiddenInput.value = "1";
                    }
                    else {
                        hiddenInput.value = "0";
                    }
                    calcPrice();
                }, 0);
            });
        });
    }
};
const calcPrice = () => {
    const finalPrice = document.querySelector(".showcase-product.is-visible .final-price");
    if (finalPrice) {
        let total = 0;
        for (let i = 0; i < document.querySelectorAll(".showcase-product.is-visible [data-prices-container] [data-price-checkbox]:checked").length; i++) {
            total += parseFloat(document.querySelectorAll(".showcase-product.is-visible [data-prices-container] [data-price-checkbox]:checked")[i].parentElement.querySelector("[data-price]").innerHTML.trim());
        }
        finalPrice.innerHTML = total.toString();
    }
};
